import * as React from "react"
import {Skeleton} from "@mui/material"

import { TitleWithPopover, AppTableSeeker } from "@components"
import { sellerColumn, numWinsColumn } from "./columns"
import { useLostBuyBoxOverviewTableCompetitorsData } from "../@hooks"


const HEIGHT = 280


export default function LostBuyBoxOverviewCompetitorsTable() {

	const { competitorsTableData, isLoadingCompetitorsTable } = useLostBuyBoxOverviewTableCompetitorsData()

	if (isLoadingCompetitorsTable) return <Skeleton variant="rectangular" height={250} />
	if (!competitorsTableData?.length) return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title='Top 10 Competitors Winning the Buy Box' />}
		data={competitorsTableData}
		columns={[
			sellerColumn(),
			numWinsColumn()
		]}
		options={{
			tableBodyHeight: `${HEIGHT}px`,
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			pagination: false,
		}}
	/>

}